'use client';

import { LocationHydration } from 'stores/LocationStore';
import dynamic from 'next/dynamic';

import { InstantSearch } from 'react-instantsearch';
import searchClient from 'utils/algolia';
import { ALGOLIA_INDEX_NAME } from 'constants/algolia';

import HeaderFilters from './components/HeaderFilters/HeaderFilters';
import * as styles from './NewHeaderContext.css';

const AlgoliaSearch = dynamic(() => import('components/AlgoliaSearch/AlgoliaSearch'), { ssr: false });

function NewHeaderContext({
  locationHydration,
  isNavbarCollapsed = false,
}: {
  locationHydration: LocationHydration;
  isNavbarCollapsed?: boolean;
}) {
  return (
    <div className={`${styles.container} ${isNavbarCollapsed && styles.colapsedContainer}`}>
      <InstantSearch searchClient={searchClient} indexName={ALGOLIA_INDEX_NAME} insights>
        <AlgoliaSearch isNavbarCollapsed={isNavbarCollapsed} />
      </InstantSearch>
      <HeaderFilters locationHydration={locationHydration} isNavbarCollapsed={isNavbarCollapsed} />
    </div>
  );
}

export default NewHeaderContext;
